export default __webpack_public_path__ + "static/media/TNAA-marquee-neon1.b196d9ae.jpg";